import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './search-facets.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class SearchFacets extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      itemList: { type: Object },
      facetId: { type: String },
      styleclass: { type: String },
    };
  }

  constructor() {
    super();
    this.facetId = '';
    this.styleclass = 'default';
  }

  handleClearClick() {
    window.dispatchEvent(new CustomEvent('hf-facets-global-reset'));
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const searchValue = urlParams.get('search');
    const currentURL = window.location.href.split(/[?#]/)[0];

    window.location.href = currentURL + '?search=' + searchValue;
  }

  render() {
    return html`
      <div
        class="${classMap({
          'hf-search-facets': true,
          [`hf-search-facets--${this.styleclass}`]: this.styleclass,
        })}"
      >
        <ul
          class="${classMap({
            'hf-search-facets__items': true,
          })}"
        >
          ${this.itemList.map(item => {
            return html`
              <li class="hf-search-facets__item">
                <hf-search-filter-item
                  type="checkbox"
                  .facetId="${item.id}"
                  .label="${item.label}"
                  .value="${item.value}"
                  ?isActive="${item.active}"
                  count=${item.count}
                >
                </hf-search-filter-item>
              </li>
            `;
          })}
          <li @click="${this.handleClearClick}" class="hf-search-facets__clear">
            <span>Clear</span>
          </li>
        </ul>
      </div>
    `;
  }
}
customElements.define('hf-search-facets', SearchFacets);
